export default ({ request }) => ({

  scmTagListApi(data) {
    return request({
      url: '/digitalCenter/scmTag/list',
      method: 'post',
      data
    })
  },
  scmTagDetailApi(data) {
    return request({
      url: '/digitalCenter/scmTag/detail',
      method: 'post',
      data
    })
  },
  scmTagSaveApi(data) {
    return request({
      url: '/digitalCenter/scmTag/save',
      method: 'post',
      data
    })
  },
  scmTagUpdateStatusApi(data) {
    return request({
      url: '/digitalCenter/scmTag/updateStatus',
      method: 'post',
      data
    })
  }
})
